const envUrl = process.env.REACT_APP_BACKEND_URL;
// Em produção (self-host) atrás do Nginx, usamos a mesma origem da página.
// No preview/dev, usamos a variável de ambiente.
const origin = typeof window !== "undefined" ? window.location.origin : "";
const BASE = envUrl && envUrl.trim() ? envUrl : origin;

export const API = `${BASE}/api`;
export const WS_BASE = BASE.replace(/^http/, "ws") + "/api";
